export enum CommunicationType {
	TELEFON = 'TELEFON',
	EMAIL = 'EMAIL',
}
